var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsidebarControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.01611C9 2.35926 10.3431 1.01611 12 1.01611C13.6569 1.01611 15 2.35926 15 4.01611C15 5.67297 13.6569 7.01611 12 7.01611C10.3431 7.01611 9 5.67297 9 4.01611ZM9 4.01611L1 4.01611M7 12.0161C7 13.673 5.65685 15.0161 4 15.0161C2.34315 15.0161 1 13.673 1 12.0161C1 10.3593 2.34315 9.01611 4 9.01611C5.65685 9.01611 7 10.3593 7 12.0161ZM7 12.0161H15",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsidebarControl);
export default __webpack_public_path__ + "static/media/iconsidebar_control.19aad2e6c4c3e70ae447a4bd71cf2bbd.svg";
export { ForwardRef as ReactComponent };